import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { BlogGrid, BlogDiv, BlogTitle } from "./styles";
import { CardBlog } from "./CardBlog";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/intarfaces";
import { useNavigate } from "react-router-dom";
import { ContentDiv } from "components/containers";

// This number need to change when added new posts
const amountPosts = 44;

export const Blog: React.FC = () => {
  const { t, i18n } = useTranslation('blog');

  const [posts, setPosts] = useState<string[]>([]);
  const navigate = useNavigate()
  useEffect(() => {
    const blogPosts: string[] = Array(amountPosts)
      .fill("post")
      .map((_, index) => "post" + (index + 1))
      .reverse();
    setPosts(blogPosts);
  }, [i18n.language]);

  const seo = t("blog.seo", { returnObjects: true }) as ISeo;

  useEffect(() => {
    posts.length && navigate({ search: '?f=f' }, { replace: true })
  }, [navigate, posts])

  return (
    <ContentDiv>
      {seo && <HeaderSEO {...seo} />}
      <BlogTitle>{t("blog.title.1")} <span>{t("blog.title.2")}</span></BlogTitle>
      <BlogGrid>
        {posts.length &&
          posts.map((item, j) => <CardBlog keyPost={item} key={j} />)}
      </BlogGrid>
      <div style={{ height: 1, background: 'white' }} />
    </ContentDiv>
  );
};
